import storeManager from './storeManager';

const setStore = store =>
  storeManager.store = store;

export default setStore;